import React from 'react'
import { InputContainer } from '../../../../../common/components/form/form.module';

export default function ModalPackageItemComponent({ selectedPackageItem, PackageType, Close
  , handlePackageItemSubmit, ProductLists, categoryListItems, variantLists, handleInnerFormChange }: any) {


  return (

    <div className="  w-full p-2 bg-white shadow-md rounded-md">
      <h1 className="text-xl font-bold mb-4 text-center">Add New Package Item</h1>
      <div className=' grid md:grid-cols-2 lg:grid-cols-3 gap-4'>

        <InputContainer
          label="Dangerous goods"
          name="dangerous_goods"
          onValueChange={(event: any) => {
            handleInnerFormChange(
              event,
              'dangerous_goods'
            )
          }}
          type="checkbox"
          value={selectedPackageItem?.dangerous_goods}
        />

        <InputContainer
          label="packageType *"
          labelField="name"
          list={PackageType}
          onValueChange={(event: any, newValue: any) => {
            handleInnerFormChange(
              event.target.value,
              'packageType'

            );
          }}
          optionName='Choose PackageType'
          type="select"
          value={selectedPackageItem?.packageType}
          valueField="name"
        />
        <InputContainer
          label="Product Category *"
          labelField="Name"
          list={categoryListItems?.result?.items}
          onValueChange={(event: any, newValue: any) => {
            handleInnerFormChange(
              event.target.value,
              'CategoryId'

            );
          }}
          optionName='Choose Category'
          type="select"
          value={selectedPackageItem?.CategoryId}
          valueField="Id"
        />
        <InputContainer
          label="Product *"
          labelField="Name"
          list={ProductLists?.result?.items}
          onValueChange={(event: any, newValue: any) => {
            handleInnerFormChange(
              event.target.value,
              'LogisticsProductId'

            );
          }}
          optionName='Choose Product'
          type="select"
          value={selectedPackageItem?.LogisticsProductId}
          valueField="Id"
        />
        <InputContainer
          label="Variant *"
          labelField="Name"
          list={variantLists?.result?.items}
          onValueChange={(event: any, newValue: any) => {
            handleInnerFormChange(
              event.target.value,
              'LogisticsVariantId'

            );
          }}
          optionName='Choose Variant'
          type="select"
          value={selectedPackageItem?.LogisticsVariantId}
          valueField="Id"
        />
        <InputContainer
          label="Weight"
          name="weight"
          onValueChange={(event: any) => {
            handleInnerFormChange(
              event.target.value,
              'weight'

            )
          }}
          type="number"
          value={selectedPackageItem?.weight}
        />
        <InputContainer
          label="Product Value *"
          name="value"
          onValueChange={(event: any) => {
            handleInnerFormChange(
              event.target.value,
              'value'

            )
          }}
          type="number"
          value={selectedPackageItem?.value}
        />
        <InputContainer
          label="Number of Items *"
          name="quantity"
          onValueChange={(event: any) => {
            handleInnerFormChange(
              event.target.value,
              'quantity'

            )
          }}
          type="number"
          value={selectedPackageItem?.quantity}
        />
        {selectedPackageItem?.packageType == 'Custom Package' ?
          <InputContainer
            label="Measure"
            name="measure"
            onValueChange={(event: any) => {
              handleInnerFormChange(
                event.target.value,
                'measure'

              )
            }}
            type="number"
            value={selectedPackageItem?.measure}
          /> : <></>
        }
        {selectedPackageItem?.packageType == 'Custom Package' ?
          <InputContainer
            label="Breadth"
            name="breadth"
            onValueChange={(event: any) => {
              handleInnerFormChange(
                event.target.value,
                'breadth'

              )
            }}
            type="number"
            value={selectedPackageItem?.breadth}
          /> : <></>
        }
        {selectedPackageItem?.packageType == 'Custom Package' ?
          <InputContainer
            label="Height"
            name="height"
            onValueChange={(event: any) => {
              handleInnerFormChange(
                event.target.value,
                'height'

              )
            }}
            type="number"
            value={selectedPackageItem?.height}
          /> : <></>
        }
        {selectedPackageItem?.packageType == 'Custom Package' ?
          <InputContainer
            label="Length"
            name="length"
            onValueChange={(event: any) => {
              handleInnerFormChange(
                event.target.value,
                'length'

              )
            }}
            type="number"
            value={selectedPackageItem?.length}
          /> : <></>
        }
        <div className='col-span-full'>
          <InputContainer
            label="Additional Information"
            name="item_description"
            onValueChange={(event: any) => {
              handleInnerFormChange(
                event.target.value,
                'item_description'

              )
            }}
            type="text"
            value={selectedPackageItem?.item_description}
          />
        </div>
      </div>

      <div className="flex justify-end mt-6">
        <button
          onClick={Close}
          type="button"
          className="m-2 bg-blue-900 text-white rounded font-medium px-4 py-3"
        >
          Close
        </button>
        <button
          className="m-2 bg-blue-900 text-white rounded font-medium px-4 py-3"
          onClick={handlePackageItemSubmit}
          type="submit"
        >
          Save
        </button>
      </div>

    </div>



  )
}